import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase';
import { MarsinetContext } from '../context/marsinetProvider';

const usePageTracking = () => {
  const location = useLocation();
  const { access_token } = useContext(MarsinetContext);

  useEffect(() => {
    logEvent(analytics, 'page_view_marsinet', {
      page_location: location.pathname,
      page_title: document.title,
      access_token: access_token,
    });
  }, [location]);
};

export default usePageTracking;
